module.exports = __webpack_public_path__ + "static/media/Roman_Kucera.5f2cf315.jpeg";